import React, { PropsWithChildren } from 'react'

import { Props } from './model'

import styles from './style.module.scss'

export const View = ({ title, children }: PropsWithChildren<Props>) => (
	<div className={styles.wrapper}>
		<h2 className={styles.title}>{title}</h2>
		<div className={styles.content}>{children}</div>
	</div>
)
